import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import Swal from 'sweetalert2';
import { AddUserModel } from '../../../features/user-management/consumer-ambassadors/models/add-user';
import { ManageUsersService } from '../../../features/user-management/consumer-ambassadors/services/manage-users.service';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { ConsumerAmbassadorService } from '../../../features/user-management/consumer-ambassadors/services/consumer-ambassador.service';
import { LookupsService } from 'projects/shared/src/services/lookups.service';
import { GenderEnum } from '../../../features/user-management/consumer-ambassadors/models/enum/GenderEnum';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { ConsumerAmbassadorsProfile } from '../../../features/user-management/consumer-ambassadors/models/ConsumerAmbassadorsProfile';
import { Patterns } from 'projects/shared/src/helpers/patterns';
import { CustomValidator } from 'projects/shared/src/helpers/custom.validator';
export interface DialogData {
  isProfile: boolean;
  record: ConsumerAmbassadorsProfile;
}
@Component({
  selector: 'app-create-user-model',
  standalone: false,
  templateUrl: './create-user-model.component.html'
})
export class CreateUserModelComponent extends DirtyComponent {
  loading = false
  dataLoading = false
  override formGroup: FormGroup = new FormGroup({});
  newUserObject: AddUserModel = new AddUserModel();
  countries: any;
  cities: any[] = [];
  Nationalities: any;
  enableCity = false;
  formErrors: any = [];

  userDetails!: ConsumerAmbassadorsProfile;
  minDate = new Date(1950, 4, 22);
  maxDate = new Date(2002, 3, 22);
  countryKey: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  date: any;
  genderEnum = GenderEnum


  // image file
  fileToUpload: any;
  imageSrc!: string;
  maxFileSize = 2;
  fileTypeError = false;
  fileSizeError = false;
  removeUserImage = false;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private service: ConsumerAmbassadorService,
    private lookupsService: LookupsService,
    private swalService: SwalService,
    private el: ElementRef,
    translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    override dialogRef: MatDialogRef<CreateUserModelComponent>,
  ) {
    super(translate)
  }

  ngOnInit(): void {
    this.buildForm()
    if (this.data.record) {
      this.dataLoading = true
      this.openUpdateForm(this.data.record);
    } else {
      this.getCountries();

    }

  }

  getCountries() {
    this.dataLoading = true
    this.lookupsService.getAllCountries().subscribe(
      data => {
        this.countries = data;
        if (this.data.record) {
          this.formGroup.get('countryId')?.setValue(this.userDetails.country.id);
          this.getCitiesId(this.userDetails.country.id, this.userDetails.city.id);
        } else {
          this.formGroup.get('countryId')?.setValue(1);
          this.getCitiesId(1, 4);

        }

        this.dataLoading = false
      },
      error => {
        console.log('Try again!, ' + error);
        this.dataLoading = false
      });
  }
  getCitiesId(countryId: any, updateCity: any = undefined) {
    let cId = countryId.value;
    if (updateCity !== undefined) {
      cId = countryId;
    }

    var countryIndex = this.countries.find((e: any) => e.id == cId);
    if (countryIndex && countryIndex.code) {
      this.countryKey = countryIndex.code;
    }

    if (countryId.value !== '') {
      this.enableCity = true;
      this.lookupsService.getCitiesByCountryId(cId).subscribe(
        data => {
          this.cities = data as [];
          if (updateCity !== undefined) {
            var check = this.cities.findIndex(e => e.id == updateCity);
            if (check > -1)
              this.formGroup.get('cityId')?.setValue(updateCity);
          } else {
            this.formGroup.get('cityId')?.setValue('');
          }
          console.log('data is ', this.cities);
        },
        error => {
          console.log('Try again!, ' + error);
        });
    }
  }

  // form method
  buildForm() {
    this.formGroup = this.formBuilder.group({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(Patterns.email),
      ]),
      fullEnglishName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9 _-]+$')
      ]),
      fullArabicName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern('^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9 _-]+$')

      ]),
      phoneNumber: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^((\\+91-?)|0)?[0-9]{1,12}$')
      ]),
      countryId: new UntypedFormControl('', Validators.required),
      cityId: new UntypedFormControl(81, Validators.required),
      dateOfBirth: new UntypedFormControl('', Validators.required),
      identityNumber: new UntypedFormControl('',
        [
          CustomValidator.noWhiteSpace,
          Validators.maxLength(10),
          Validators.pattern(/^[12][0-9]{9}$/)
        ]
      ),
      genderEnum: new UntypedFormControl(GenderEnum.MALE, Validators.required),
    });
  }

  clearDate(event: any) {
    event.stopPropagation();
    this.date = null;
  }
  saveUser() {
    if (this.formGroup.valid) {
      this.loading = true;
      this.executeUserSubs(this.formGroup.getRawValue());
    } else {
      this.formGroup.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }
  openUpdateForm(user: any) {
    const userId = user.id;
    this.service.getConsumerAmbassadorUserDetails(userId).subscribe(
      (data: any) => { // open edit popup
        this.userDetails = data;

        this.getCountries()
        this.formGroup.get('email')?.setValue(data.email);
        this.formGroup.get('fullArabicName')?.setValue(data.fullArabicName);
        this.formGroup.get('fullEnglishName')?.setValue(data.fullEnglishName);
        this.formGroup.get('dateOfBirth')?.setValue(data.dateOfBirth);
        this.formGroup.get('identityNumber')?.setValue(data.identityNumber);
        this.formGroup.get('phoneNumber')?.setValue(data.phoneNumber);
        this.formGroup.get('genderEnum')?.setValue(data.genderEnum);
        if (data.profilePicture) {
          this.imageSrc = data.profilePicture;
        }
      },
      (error: any) => {
        console.log('Try again!, ' + error);
      });
  }
  executeUserSubs(formValues: any) {
    this.setFormFieldsValues(formValues);

    let title = this.translate.instant('swalMsg.savedsuccessfully');

    if (this.data.record) {
      title = this.translate.instant('swalMsg.updatedsuccessfully');
    }
    this.service.saveUser(this.newUserObject, this.fileToUpload).subscribe(
      data => {
        this.loading = false
        Swal.fire({
          title: title,
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);

      },
      error => {
        this.loading = false;
        this.handleErrors(error.detail);
      });
  }


  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      if (error.ErrorCode == 'EmailExist') {
        this.formGroup.get('email')?.setErrors({ notUniqe: true })
      } else if (error.ErrorCode == 'PhoneNumberExist') {
        this.formGroup.get('phoneNumber')?.setErrors({ notUniqe: true })
      } else if (error.ErrorCode == 'Repeated') {
        this.formGroup.get('identityNumber')?.setErrors({ notUniqe: true })
      } else {
        this.swalService.swalFailed(error.Error);
      }
    });
    setTimeout(() => {
      this.scrollToFirstInvalidControl();
    }, 100);
  }

  setFormFieldsValues(formGroupValue: any) {
    this.newUserObject = {
      email: formGroupValue.email,
      fullArabicName: formGroupValue.fullArabicName,
      fullEnglishName: formGroupValue.fullEnglishName,
      phoneExtension: this.countryKey,
      phoneNumber: formGroupValue.phoneNumber,
      countryId: formGroupValue.countryId,
      cityId: formGroupValue.cityId,
      dateOfBirth: formGroupValue.dateOfBirth,
      identityNumber: formGroupValue.identityNumber,
      genderEnum: formGroupValue.genderEnum,
      removeUserImage: this.removeUserImage
    };
    // if (this.data.record && formGroupValue.dateOfBirth !== this.data.record.dateOfBirth) {
    //   this.newUserObject.dateOfBirth = this.datePlusDay(formGroupValue.dateOfBirth);
    // }
    if (this.data.record) {
      this.newUserObject.userId = this.data.record.id;
    }
  }


  // File preview with validation
  changeFileListener($event: any): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file)) {
      this.readThis(file);
      this.fileToUpload = file;
      this.removeUserImage = false
    } else {
      this.imageSrc = this.imageSrc;
      this.fileToUpload = this.fileToUpload;
    }
  }
  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.imageSrc = myReader.result as string;
    };
  }
  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileTypeError = false;
      if ((file.size / (1024 * 1024)) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }

  removeImg($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.imageSrc = ''
    this.removeUserImage = true
  }


  datePlusDay(date: any) {
    let newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

}
